import React from "react";
import "./CoreValues.scss";
import coreValuesdBg from "../../../assets/About/core-values-bg.png";
import useAboutUs from "../../../hooks/useAboutUs";

import caoreValuesImg from "../../../assets/About/core-value.png";

const CoreValues = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  let coreData = aboutUs.filter((value) => value.DescType === "Core Values");

  return (
    <>
      <div className="core_values">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${coreValuesdBg})` }}
            data-aos="zoom-in"
          ></div>
          <div className="heading_box">Core Values</div>
        </div>

        <div className="container">
          <div className="core_values_content">
            <div className="core_values_img text-center">
              <img src={caoreValuesImg} className="img-fluid" alt="" />
              {/* <img src={codeImg3} className="img-fluid" alt="" /> */}
            </div>

            <div
              className="mt-5"
              data-aos="fade-up"
              data-aos-anchor-placement="bottom-bottom"
            >
              {coreData.map((core, index) => (
                <div key={index} className="text_content">
                  <h4>{core.Title}</h4>
                  <ul>
                    <li>{core.Description}</li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoreValues;
